// Detects the base URL where the React app is deployed by inspecting the
// loaded JavaScript bundle. Returns something like "/new" (subfolder deploy)
// or "" (root deploy). This makes asset paths work in either configuration
// without needing to rebuild.

function detect() {
  if (typeof document === "undefined") return "";
  const scripts = document.getElementsByTagName("script");
  for (let i = 0; i < scripts.length; i++) {
    const src = scripts[i].src || "";
    const m = src.match(/^(.*?)\/static\/js\/main\./);
    if (m) {
      try {
        const u = new URL(m[1]);
        // strip any trailing slash
        return u.pathname.replace(/\/$/, "");
      } catch (_e) {
        return m[1].replace(/\/$/, "");
      }
    }
  }
  return "";
}

export const BASE_PATH = detect();

// Use this for static assets bundled into /public (e.g. photos)
export const asset = (path) => {
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `${BASE_PATH}${clean}`;
};
